import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Modal } from "react-bootstrap";
import classes from "./MessageDetailsModal.module.css";
import { starIconss } from "../../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { TextArea } from "../../../../stories/TextArea/TextArea";

const MessageDetailsModal = ({ show, setShow }) => {
  const [msg, setMsg] = useState('')
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        showCloseIcon={true}
        footerStyles={{ padding: "16px 32px" }}
        footer={
          <div className={classes.modalButtons2}>
            <LinkButtonWithIcon
              primary={false}
              text="Cancel"
              customStyle={{ marginRight: "48px" }}
              onClick={() => setShow(false)}
            />
            <Button
              size="Medium"
              label="Send"
              primary={true}
              style={{
                width: "max-content",
                padding: "14px 47px",
              }}
              onClick={() => setShow(false)}

            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            Message to: John Johnson
          </h4>
          <div className={classes.rating}>
            <img src={starIconss} alt="starIconsss" />
            <h6
              style={{
                ...Fonts.h7,
                color: Colors.neutralShadesOfNero,
                margin: "15px 0",
              }}
            >
              5.0
            </h6>
          </div>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            Cancellations: 2
          </p>
          <div className={classes.wrapperTextarea}>

            <TextArea
              label={'Details'}
              state={msg}
              setter={setMsg}
            />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default MessageDetailsModal;
